import jwtAuthAxios from "../auth/jwtAuth";
import { setAuthBackendDomain } from "./management";

export const getPresentation = async (url) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    `/presentation/getPresentation?url=${url}`
  );
  return data.data && data.data.presentation;
};

export const getPresentations = async (customerId) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    `/presentation/all?customerId=${customerId}`
  );
  return data.presentations;
};

export const addPresentation = async (presentation) => {
  const { userId, customerId, label } = presentation;
  const bodyFormData = new FormData();
  bodyFormData.append("userId", userId);
  bodyFormData.append("customerId", customerId);
  bodyFormData.append("label", label);
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(
    "/presentation/create",
    bodyFormData
  );
  return data.presentationUrl;
};

export const updatePresentation = async (presentation) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(
    "/presentation/update",
    presentation
  );
  return data;
};

export const copyPresentation = async (url) => {
  setAuthBackendDomain(jwtAuthAxios);
  const bodyFormData = new FormData();
  bodyFormData.append("url", url);
  const { data } = await jwtAuthAxios.post("/presentation/copy", bodyFormData);
  return data;
};

export const refreshPresentation = async (url) => {
  setAuthBackendDomain(jwtAuthAxios);
  const bodyFormData = new FormData();
  bodyFormData.append("url", url);
  const { data } = await jwtAuthAxios.post(
    "/presentation/refresh",
    bodyFormData
  );
  return data;
};

export const deletePresentation = async (url) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.delete(`/presentation/delete?url=${url}`);
  return data;
};
